import { createStyles, makeStyles } from '@mui/styles';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		collapsedTabsPanel: {
			width: '3rem',
			paddingTop: '1rem',
			order: '2',
			borderLeft: `solid 1px ${Colors.neutral300}`
		},
		headerTitle: {
			display: 'flex',
			gap: '0.5rem',
			alignItems: 'center',
			fontSize: '1.125rem',
			lineHeight: '1.5rem',
			color: Colors.neutral900,
			fontWeight: 500,
			whiteSpace: 'nowrap'
		},
		collapsedTabs: {
			display: 'flex',
			gap: '1rem',
			alignItems: 'center',
			height: '3rem',
			flexDirection: 'row',
			transform: 'rotate(180deg)'
		},
		rotateCollapsedTabs: {
			display: 'flex',
			transform: 'rotate(90deg)',
			transformOrigin: '0 0',
			marginLeft: '3rem'
		}
	})
);

export interface ICollapsedTabsProps {
	onOpen: () => void;
	title: string;
	hidden?: boolean;
}

const CollapsedTabs: React.FunctionComponent<ICollapsedTabsProps> = ({ onOpen, title, hidden }) => {
	const classes = useStyles();

	return (
		<div className={classes.collapsedTabsPanel} hidden={hidden}>
			<div className={classes.rotateCollapsedTabs}>
				<div className={classes.collapsedTabs}>
					<div className={classes.headerTitle}>{title}</div>
					<button
						type="button"
						className="rup-icon-btn rup-icon-btn--neutral rup-icon-btn--sm"
						onClick={onOpen}
						data-test-id="expand-btn"
						style={{ minWidth: '1.5rem' }}
					>
						<span className="rup-icon" dangerouslySetInnerHTML={{ __html: Icons.ChevronUpIcon }} />
					</button>
				</div>
			</div>
		</div>
	);
};

export default CollapsedTabs;
